import {OmyConst} from "../../OmyConst";
import Omy from "../../Omy";
import StringUtils from "../../utils/StringUtils";

export default class OTextBitmap extends PIXI.BitmapText {
    constructor(text, style) {
        style.defaultFontName = style.fontName;
        let fontName = style.fontName;
        if (style.hasOwnProperty("locCheck") ? style["locCheck"] : true)
            fontName = Omy.assets.localAssets(style.fontName);
        style.fontName = Omy.assets.existsBitmapFont(fontName);
        super(text, style);

        this.json = style;
        this._onKillEvent = "kill_event";
        this._onReviveEvent = "revive_event";
        this._onDestroyEvent = "destroy_event";
        this._onDownEvent = "down_event";
        this._onUpEvent = "up_event";
        this._onUpOutSideEvent = "up_out_event";
        this._onOverEvent = "over_event";
        this._onOutEvent = "out_event";
        this._onDragStartEvent = "drag_start_event";
        this._onDragStopEvent = "drag_stop_event";
        this._onDragUpdateEvent = "drag_update_event";
        this._onTextEvent = "text_update_event";
        this._onCountEvent = "count_update_event";

        this._saveVisible = true;
        if (Omy.debugMode) {
            this._isOnDebugerUpdate = true;
            Omy.addUpdater(this._updateDebug, this);
        }
        this._isUpdate = false;
        this._isSplitUpdate = false;
        this.aa_isRegOnDebug = false;
        this.aa_debugFontName = "";
        this.aa_debugAlign = "";
        this.aa_debugAlignV = "";
        this.aa_letterSpacing = -1;
        this._inDebug = false;
        /**         * @type {Object}         */
        this.userData = null;
        /**         * @type {Boolean}         */
        this._active = true;

        this._boundsRect = new OmyConst.Rectangle();
        this._localBoundsRect = new OmyConst.Rectangle();
        this._oX = 0;
        this._oY = 0;
        this._oWidth = 0;
        this._oHeight = 0;
        this._charCount = 0;
        this._soundUp = null;
        this._soundOver = null;

        /**         * @type {Array}         */
        this._externalMethodParams = null;
        /**         * @type {Function}         */
        this._externalMethod = null;
        this._isDrag = false;
        this._dragVertical = false;
        this._dragHorizontal = false;
        this._isStartDrag = false;
        this._isCheckInput = false;
        this._toUpperCase = style.hasOwnProperty("toUpperCase") ? style["toUpperCase"] : false;
        this._softAlign = style.hasOwnProperty("softAlign") ? style["softAlign"] : false;
        this._checkCustomW = style.hasOwnProperty("checkCustomW") ? style["checkCustomW"] : false;
        this._isCheckSizeChange = false;
        this._ttCheckWidth = 0;
        this._ttCheckWidthMax = Omy.fps * 3;

        this._oType = OmyConst.OMY_TEXT_BITMAP;

        if (style.hasOwnProperty("fill") || style.hasOwnProperty("tint"))
            this.tint = style.fill || style.tint;

        this._pivotX = 0;
        this._pivotY = 0;
        this._splitText = null;
        this._splitInsideText = null;
        this._staticFirstText = null;
        this._staticLastText = null;
        this._textValue = text;
        this._fontDefSize = style.fontSize;
        this._fontStyle = style.fontName;
        this._defaultFontStyle = style.defaultFontName;
        this._dx = style.dx || 0;
        this._dy = style.dy || 0;
        this._maxFontSize = (Omy.resources[this._fontStyle]) ? Omy.resources[this._fontStyle]["bitmapFont"]["size"] : this._fontDefSize;
        this._positionDx = Omy.assets.getBitmapFontDx(this._defaultFontStyle);
        this._positionDy = Omy.assets.getBitmapFontDy(this._defaultFontStyle);

        this._align = style.align || "left";
        this._alignV = style.alignV || "top";
        this.align = this._align;
        this.alignV = this._alignV;

        this._checkFontSize = style["checkFontSize"] || false;
        this._fullCheckFontSize = style["fullCheckFontSize"] || false;
        this._forceCheckFontSize = style["forceCheckFontSize"] || false;

        this._textBreak = style["textBreak"] || false;

        let noHaveTextSize = (!style["height"] || !style["width"]) && !this.text.length;
        if (noHaveTextSize) this.text = "0";
        this._maxWidthConst = style["width"] || Number.MAX_VALUE;
        this._maxHeight = style["height"] || this.height;
        if (noHaveTextSize) this.text = "";
        this._locTextConf = style["locConfig"];

        if (this._locTextConf) {
            const locConfig = this._locTextConf[Omy.language];
            if (locConfig && locConfig.hasOwnProperty("toUpperCase"))
                this._toUpperCase = locConfig["toUpperCase"];
            if (locConfig && locConfig.hasOwnProperty("dx"))
                this._dx = locConfig["dx"];
            this.align = this.align;
            if (locConfig && locConfig.hasOwnProperty("dy"))
                this._dy = locConfig["dy"];
            this.alignV = this.alignV;
        }

        if (style["locConst"]) {
            this._isLocText = true;
            Omy.loc.addUpdate(this._updateText, this);
        } else {
            this._isLocText = false;
        }
        this._locCheck = style.hasOwnProperty("locCheck") ? style["locCheck"] : true;
        this._isLocalFont = Omy.assets.isLocalAssets(this._defaultFontStyle) && this._locCheck;
        if (this._isLocalFont && !this._isLocText)
            Omy.loc.addUpdate(this._updateText, this);
        if (style["letterSpacing"]) {
            this.letterSpacing = style["letterSpacing"];
        }
        if (style.hasOwnProperty("resolution")) {
            this.resolution = style["resolution"];
        }
        this.roundPixels = ((style.hasOwnProperty("roundPixels")) ? style["roundPixels"] : true);

        this._oneLine = style.hasOwnProperty("oneLine") ? style["oneLine"] : true;
        if (this._oneLine) {
            this.maxWidth = Number.MAX_VALUE;
        } else {
            this.maxWidth = this._maxWidthConst;
        }
        this._splitDx = style["splitDx"] || 0;
        this._splitVector = (style["splitVector"] !== -1) ? 1 : style["splitVector"];
        this._hinField = style["hin"] || null;
        if (Omy.language === "hin" && this._hinField)
            this._fontField = Omy.add.textJson(this, this._hinField);
        /** @type {Array.<PIXI.DisplayObject>} */
        this._joinObjects = null;
        this._joinUpdatePause = true;
        this.text = this._textValue;
        this.interactChild = false;
        this._saveOnDestroy = false;
    }

    /**     * @private     */
    _updateDebug() {
        if (this.cullable) {
            this.aa_isRegOnDebug = !this.aa_isRegOnDebug;
            this.cullable = false;
        }
        if (this.aa_isRegOnDebug && !this._inDebug) {
            Omy.add.regDebugMode(this);
        } else if (!this.aa_isRegOnDebug && this._inDebug) {
            Omy.add.removeFromDebug(this);
        }
        if (this.aa_debugFontName.length) {
            this.setNewFont(this.aa_debugFontName);
            this.aa_debugFontName = "";
        }
        if (this.aa_debugAlign.length) {
            this.align = this.aa_debugAlign;
            if (this._graphicOverlay) {
                this._graphicOverlay.destroy();
                this._graphicOverlay = null;
                this.drawDebugRect();
            }
            this.aa_debugAlign = "";
        }
        if (this.aa_debugAlignV.length) {
            this.alignV = this.aa_debugAlignV;
            if (this._graphicOverlay) {
                this._graphicOverlay.destroy();
                this._graphicOverlay = null;
                this.drawDebugRect();
            }
            this.aa_debugAlignV = "";
        }
        if (this.aa_letterSpacing !== -1) {
            this.letterSpacing = this.aa_letterSpacing;
            this.aa_letterSpacing = -1;
        }
    }

    drawDebugRect() {
        if (this._graphicOverlay) {
            this._graphicOverlay.width = Math.max(this._maxWidthConst, this.width);
            this._graphicOverlay.height = Math.max(this._maxHeight, this.height);
            this._graphicOverlay.rotation = this.rotation;
            this._updateDebugPosition();
        } else {
            this._graphicOverlay = new OmyConst.Graphics();
            this._graphicOverlay.position.set(this.worldX, this.worldY);
            this._graphicOverlay.beginFill(0xff3245, 0.5);
            let align = this.align || "left";
            let alignV = this.alignV || "top";
            let x = 0,
                y = 0;
            switch (align) {
                case "left": {
                    x = 0;
                    break;
                }
                case "center": {
                    x = -Math.max(this._maxWidthConst, this.width) * .5;
                    break;
                }
                case "right": {
                    x = -Math.max(this._maxWidthConst, this.width);
                    break;
                }
            }
            switch (alignV) {
                case "top": {
                    y = 0;
                    break;
                }
                case "middle": {
                    y = -Math.max(this._maxHeight, this.height) * .5;
                    break;
                }
                case "bottom": {
                    y = -Math.max(this._maxHeight, this.height);
                    break;
                }
            }

            this._graphicOverlay.drawRect(x, y, Math.max(this._maxWidthConst, this.width), Math.max(this._maxHeight, this.height));
            this._graphicOverlay.endFill();
            this._graphicOverlay.rotation = this.rotation;
        }

        Omy.stage.addChild(this._graphicOverlay);
    }

    /**     * @public     */
    removeDrawDebugRect() {
        if (this._graphicOverlay && this._graphicOverlay.parent)
            Omy.stage.removeChild(this._graphicOverlay);
    }

    _updateDebugPosition() {
        this._graphicOverlay.x = this.worldX;
        this._graphicOverlay.y = this.worldY;
    }

    resetCheckScale() {
        this._charCount = 0;
    }

    _updateText() {
        this._charCount = -1;
        if (Omy.language === "hin" && this._hinField) {
            this._positionDx = 0;
            this._positionDy = 0;
            this.pivot.x = this._pivotX;
            this.pivot.y = this._pivotY;
            if (!this._fontField) this._fontField = Omy.add.textJson(this, this._hinField);
            if (!Omy.isRealDesktop && Omy.isScreenPortrait && this.json["deepPosition"])
                Omy.updateGameSizeForce(this._fontField);
            if (this._customCollor) this._fontField.setColor(this._customCollor);
            this.text = this._textValue;
            return;
        }
        if (this._fontField) {
            this._fontField.destroy();
            this._fontField = null;
        }
        this._positionDx = Omy.assets.getBitmapFontDx(this._defaultFontStyle);
        this._positionDy = Omy.assets.getBitmapFontDy(this._defaultFontStyle);
        if (this._locTextConf) {
            const locConfig = this._locTextConf[Omy.language];
            if (locConfig && locConfig.hasOwnProperty("toUpperCase"))
                this._toUpperCase = locConfig["toUpperCase"];
            else
                this._toUpperCase = this.json.hasOwnProperty("toUpperCase") ? this.json["toUpperCase"] : false;
            if (locConfig && locConfig.hasOwnProperty("dx"))
                this._dx = locConfig["dx"];
            else
                this._dx = this.json.dx || 0;
            this.align = this.align;
            if (locConfig && locConfig.hasOwnProperty("dy"))
                this._dy = locConfig["dy"];
            else
                this._dy = this.json.dy || 0;
            this.alignV = this.alignV;
        }
        this.setNewFont((this._isLocalFont) ? Omy.assets.localAssets(this._defaultFontStyle) : this._fontStyle);
    }

    /** @type {string | Array.<string> | number | Array.<number> | CanvasGradient | CanvasPattern} */
    setColor(tColor) {
        this._customCollor = this.tint = tColor;
        if (this._fontField) this._fontField.setColor(tColor);
    }

    /**     * @public     */
    kill() {
        if (this.destroyed) return this;
        if (this._active) {
            this._active = false;
            if (this._isUpdate)
                Omy.removeUpdater(this.update, this);
            if (this._isSplitUpdate)
                Omy.removeUpdater(this._updateCheckSplit, this);
            if (this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = false;
                Omy.removeUpdater(this._updateDebug, this);
            }
            if (this.omyTwinned) {
                Omy.remove.tween(this);
                delete this.omyTwinned;
            }

            if (this.input)
                this.input = false;
            this._saveVisible = this.visible;
            this.visible = false;
            this.renderable = false;
            this.emit(this._onKillEvent, this);
        }

        return this;
    }

    /**     * @public     */
    revive() {
        if (this.destroyed) return this;
        if (!this._active) {
            this._active = true;
            this.renderable = true;
            if (this._isUpdate)
                Omy.addUpdater(this.update, this);
            if (this._isSplitUpdate)
                Omy.addUpdater(this._updateCheckSplit, this);
            if (Omy.debugMode && !this._isOnDebugerUpdate) {
                this._isOnDebugerUpdate = true;
                Omy.addUpdater(this._updateDebug, this);
            }

            if (this.input)
                this.input = true;
            this.visible = this._saveVisible;
            this.emit(this._onReviveEvent, this);
        }

        return this;
    }

    /**     * @public     */
    destroy(options) {
        if (this.destroyed) return this;
        options = options || {children: true, texture: false, baseTexture: false};
        if (this.omyTwinned) {
            Omy.remove.tween(this);
            delete this.omyTwinned;
        }
        this.parentGroup && Omy.remove.removeFromLayer(this);
        this._locTextConf = null;
        this.json = null;
        this._active = false;
        this.userData = null;
        this._boundsRect = null;
        this._localBoundsRect = null;
        this._isDrag = false;
        this._isStartDrag = false;
        if (this._listenMouseUp) {
            this._listenMouseUp = false;
            Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        }
        this._textValue = null;
        this._splitText = null;
        this._splitInsideText = null;
        this._staticFirstText = null;
        this._staticLastText = null;
        this._eventData = null;
        this.isUpdate = false;
        if (this._isSplitUpdate)
            Omy.removeUpdater(this._updateCheckSplit, this);
        this._isSplitUpdate = false;
        if (this._isOnDebugerUpdate) {
            this._isOnDebugerUpdate = false;
            Omy.removeUpdater(this._updateDebug, this);
        }
        if (this._isLocText || this._isLocalFont)
            Omy.loc.removeUpdate(this._updateText, this);
        if (this.input) {
            this.input = false;
        }
        this.removeAllListeners(this._onDragStartEvent);
        this.removeAllListeners(this._onDragStopEvent);
        this.removeAllListeners(this._onDragUpdateEvent);
        this.removeAllListeners(this._onDownEvent);
        this.removeAllListeners(this._onOutEvent);
        this.removeAllListeners(this._onOverEvent);
        this.removeAllListeners(this._onUpEvent);
        this.removeAllListeners(this._onUpOutSideEvent);
        this.emit(this._onDestroyEvent, this);
        this.removeAllListeners(this._onDestroyEvent);
        this.removeAllListeners(this._onKillEvent);
        this.removeAllListeners(this._onReviveEvent);
        this.removeAllListeners(this._onTextEvent);
        this.removeAllListeners(this._onCountEvent);

        this._externalMethod = null;
        this._externalMethodParams = null;
        this.renderable = false;
        this.visible = false;
        this._soundUp = null;
        this._soundOver = null;
        this._hinField = null;
        this._fontField = null;
        if (this._joinObjects) {
            this._joinObjects.length = 0;
            this._joinObjects = null;
            Omy.removeUpdater(this._updateJoinPosition, this);
        }

        super.destroy(options);
        return this;
    }

    /**     * @public     */
    update() {
        if (this._isCheckSizeChange) {
            if (this._saveBoundsW !== this.getLocalBounds().width) {
                this._isCheckSizeChange = false;
                this.isUpdate = false;
                this.emit(this._onCountEvent);
            }
            if (--this._ttCheckWidth < 0) {
                this._isCheckSizeChange = false;
            }
        }
        if (this._isStartDrag) {
            if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
                if (this._dragHorizontal) {
                    this.x = this._oX + this._eventData.global.x - this._dragSaveX;

                    if (this._oX < this._dragXMin) {
                        this.x = this._dragXMin;
                    } else if (this._oX > this._dragXMax) {
                        this.x = this._dragXMax;
                    }
                }
                if (this._dragVertical) {
                    this.y = this._oY + this._eventData.global.y - this._dragSaveY;

                    if (this._oY < this._dragYMin) {
                        this.y = this._dragYMin;
                    } else if (this._oY > this._dragYMax) {
                        this.y = this._dragYMax;
                    }
                }
                this._dragSaveX = this._eventData.global.x;
                this._dragSaveY = this._eventData.global.y;
                this.emit(this._onDragUpdateEvent, this);
                if (!Omy.mouse.isDown) this._upOutSide();
            }
        }
    }

    /**     * @private     */
    _updateCheckSplit() {
        if (this._splitText) {
            if (this._saveSplitX !== this._oX || this._saveSplitWidth !== this.width) {
                this._saveSplitX = this._oX;
                this._saveSplitWidth = this.width;
                let splitTextX = 0;
                let textW = 0;
                if (this._splitVector === 1) {
                    splitTextX = this._splitText.width * (this._splitText.anchor?.x || 0);
                    textW = this.width * Math.abs(this.anchorX - 1);
                } else {
                    splitTextX = this._splitText.width * ((this._splitText.anchor?.x || 0) - 1);
                    textW = -this.width * this.anchorX;
                }
                this._splitText.x = this._oX + textW + splitTextX + this._splitVector * this._splitDx;
            }
        }
        if (this._splitInsideText && this._saveSplitWidth !== this.width) {
            this._saveSplitWidth = this.width;
            this._splitInsideText.visible = false;
            let splitTextX = 0;
            let textW = 0;
            if (this._splitVector === 1) {
                splitTextX = this._splitInsideText.width * (this._splitInsideText.anchor?.x || 0);
                textW = this.width * Math.abs(this.anchorX - 1);
            } else {
                splitTextX = this._splitInsideText.width * ((this._splitInsideText.anchor?.x || 0) - 1);
                textW = -this.width * this.anchorX;
            }
            this._splitInsideText.x = textW + splitTextX + this._splitVector * this._splitDx;
            this._splitInsideText.visible = true;
        }
    }

    _down(event) {
        if (this._isDrag) {
            this._eventData = event.data;
            this._dragSaveX = this._eventData.global.x;
            this._dragSaveY = this._eventData.global.y;
            this._isStartDrag = true;
            this.emit(this._onDragStartEvent, this);
        }

        this.emit(this._onDownEvent, this);
    }

    _over() {
        this.emit(this._onOverEvent, this);
        if (this._soundOver) Omy.sound.play(this._soundOver);
    }

    _out() {
        this.emit(this._onOutEvent, this);
    }

    _upOutSide() {
        this._out();
        this.emit(this._onUpOutSideEvent, this);
    }

    _up() {
        this.emit(this._onUpEvent, this);
        if (this._soundUp) Omy.sound.play(this._soundUp);
        if (this._externalMethod != null)
            this._externalMethod.apply(null, this._externalMethodParams);
    }

    _globalMouseUp() {
        if (this._isDrag && this._isStartDrag) {
            this._eventData = null;
            this._isStartDrag = false;
            this.emit(this._onDragStopEvent, this);
        }
    }

    setXY(ax, ay) {
        this._oX = ax;
        this._oY = ay;
        this.position.set(ax, ay);
    }

    setSize(ax, ay) {
        this.width = ax;
        this.height = ay;
    }

    setScale(ax, ay) {
        this.scale.set(ax, ay);
    }

    setAnchor(ax, ay) {
        this.anchor.set(ax, ay);
    }

    setPivot(ax, ay) {
        this.pivot.set(ax, ay);
        this.x = this._oX + ax;
        this.y = this._oY + ay;
    }

    _checkScale() {
        if (this._locTextConf && this._locTextConf[Omy.language] && !this._graphicOverlay) {
            const fontSize = (Omy.isScreenPortrait) ? this._locTextConf[Omy.language]["v_fontSize"] || this._locTextConf[Omy.language]["fontSize"] : this._locTextConf[Omy.language]["fontSize"];
            super.fontSize = fontSize || this._fontDefSize;
            this._forceCheckFontSize && this._findNeedSize();
        } else {
            super.fontSize = this._fontDefSize;
            this._checkFontSize && this._findNeedSize();
        }
    }

    /**     * @private     */
    _findNeedSize() {
        try {
            this.getLocalBounds();
        } catch (err) {
            OMY.Omy.warn("cannot get local bounds", this.text);
            return;
        }
        let maxValue = this._oneLine ? this._maxWidthConst : this._maxHeight;
        let needParam = this._oneLine ? "localWidth" : "localHeight";
        let localWidth = this.localWidth;
        if (maxValue < this[needParam]) {
            let fontSize = this._fontDefSize;
            super.fontSize = fontSize;
            this.getLocalBounds();
            localWidth = this.localWidth;
            let checkValue = 0;
            while (fontSize > 0) {
                fontSize--;
                checkValue = this[needParam] * (fontSize / this._fontDefSize);
                if (maxValue >= checkValue) {
                    super.fontSize = fontSize;
                    break;
                }
            }
        }
        if (this._fullCheckFontSize && !this._oneLine) {
            maxValue = this._maxWidthConst - 30;
            if (maxValue < localWidth) {
                let fontSize = super.fontSize;
                let checkValue = 0;
                while (fontSize > 0) {
                    fontSize--;
                    checkValue = localWidth * (fontSize / this._fontDefSize);
                    if (maxValue >= checkValue) {
                        super.fontSize = fontSize - 1;
                        break;
                    }
                }
            }
        }
    }

    /**
     * Change text font style and font size
     * @param {String} fontFamily
     */
    setNewFont(fontFamily) {
        if (fontFamily) this._fontStyle = this.fontName = fontFamily;
        this._maxFontSize = (Omy.resources[this._fontStyle]) ? Omy.resources[this._fontStyle]["bitmapFont"]["size"] : this._fontDefSize;
        super.text = "";
        this.text = this._textValue;
    }

    /**
     * @param {Function}eMethod
     * @param {Array}methodParams
     */
    externalMethod(eMethod, methodParams) {
        if (!this.input)
            this.input = true;
        this._externalMethod = eMethod;
        this._externalMethodParams = methodParams;
    }

    boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
        if (!isNaN(rXMin))
            this._dragXMin = rXMin;
        if (!isNaN(rYMin))
            this._dragYMin = rYMin;
        if (!isNaN(rXMax))
            this._dragXMax = rXMax;
        if (!isNaN(rYMax))
            this._dragYMax = rYMax;
    }

    forceUpdateWidth() {
        this._isCheckSizeChange = true;
        this._ttCheckWidth = this._ttCheckWidthMax;
        this.isUpdate = true;
        this._saveBoundsW = this.getLocalBounds().width;
    }

    addOver(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOverEvent, func, context, once);
    }

    addOut(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onOutEvent, func, context, once);
    }

    addDown(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onDownEvent, func, context, once);
    }

    addUp(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpEvent, func, context, once);
    }

    addUpOutSide(func, context, once) {
        if (!this.input)
            this.input = true;
        this._addNewEvent(this._onUpOutSideEvent, func, context, once);
    }

    addDragUpdate(func, context, once) {
        this._addNewEvent(this._onDragUpdateEvent, func, context, once);
    }

    addDragStart(func, context, once) {
        this._addNewEvent(this._onDragStartEvent, func, context, once);
    }

    addDragStop(func, context, once) {
        this._addNewEvent(this._onDragStopEvent, func, context, once);
    }

    addKill(func, context, once) {
        this._addNewEvent(this._onKillEvent, func, context, once);
    }

    addRevive(func, context, once) {
        this._addNewEvent(this._onReviveEvent, func, context, once);
    }

    addDestroy(func, context, once) {
        this._addNewEvent(this._onDestroyEvent, func, context, once);
    }

    addTextUpdate(func, context, once) {
        this._addNewEvent(this._onTextEvent, func, context, once);
    }

    addCharCountUpdate(func, context, once) {
        this._addNewEvent(this._onCountEvent, func, context, once);
    }

    /**     * @private     */
    _addNewEvent(event, func, context, once = false) {
        if (once)
            this.once(event, func, context);
        else
            this.on(event, func, context);
    }

    removeOver(func, context) {
        this.removeListener(this._onOverEvent, func, context);
    }

    removeOut(func, context) {
        this.removeListener(this._onOutEvent, func, context);
    }

    removeDown(func, context) {
        this.removeListener(this._onDownEvent, func, context);
    }

    removeUp(func, context) {
        this.removeListener(this._onUpEvent, func, context);
    }

    removeUpOutSide(func, context) {
        this.removeListener(this._onUpOutSideEvent, func, context);
    }

    removeDragUpdate(func, context) {
        this.removeListener(this._onDragUpdateEvent, func, context);
    }

    removeDragStart(func, context) {
        this.removeListener(this._onDragStartEvent, func, context);
    }

    removeDragStop(func, context) {
        this.removeListener(this._onDragStopEvent, func, context);
    }

    removeKill(func, context) {
        this.removeListener(this._onKillEvent, func, context);
    }

    removeRevive(func, context) {
        this.removeListener(this._onReviveEvent, func, context);
    }

    removDestroy(func, context) {
        this.removeDestroy(func, context);
    }

    removeDestroy(func, context) {
        this.removeListener(this._onDestroyEvent, func, context);
    }

    removeTextUpdate(func, context) {
        this.removeListener(this._onTextEvent, func, context);
    }

    removeCharCountUpdate(func, context) {
        this.removeListener(this._onCountEvent, func, context);
    }

    /**
     * add object to join update position
     * @param {PIXI.DisplayObject} object
     */
    regJoinObjects(object) {
        if (!object) return;
        if (this._joinObjects == null) {
            this._joinObjects = [];
            this.joinUpdatePause = false;
        }
        object.joinX = object.json["joinX"] || 0;
        object.joinY = object.json["joinY"] || 0;
        this._joinObjects.push(object);
    }

    /**     * @private     */
    _updateJoinPosition() {
        if (!this._active) return;
        let i = 0;
        let o;
        while (i < this._joinObjects.length) {
            o = this._joinObjects[i++];
            if (o.active && ((o.x !== this.x + o.joinX) || (o.y !== this.y + o.joinY))) {
                o.x = this.x + o.joinX;
                o.y = this.y + o.joinY;
            }
        }
    }

//---------------------------------------
/// ACCESSOR
//--------------------------------------
    get align() {
        return this._align;
    }

    set align(value) {
        this._align = value;
        if (!this._softAlign) {
            switch (value) {
                case "left":
                    this.anchorX = this._dx;
                    break;

                case "center":
                    this.anchorX = .5 + this._dx;
                    break;

                case "right":
                    this.anchorX = 1 + this._dx;
                    break;

                default:
                    Omy.error("not exists value ", value);
                    break;
            }
        }
        super.align = value;
    }

    get alignV() {
        return this._alignV;
    }

    set alignV(value) {
        this._alignV = value;
        switch (value) {
            case "top":
                this.anchorY = this._dy;
                break;

            case "middle":
                this.anchorY = .5 + this._dy;
                break;

            case "bottom":
                this.anchorY = 1 + this._dy;
                break;

            default:
                Omy.error("not exists value ", value);
                break;
        }
    }

    set isUpdate(value) {
        if (!this._isUpdate && value) {
            Omy.addUpdater(this.update, this);
        } else if (this._isUpdate && !value) {
            Omy.removeUpdater(this.update, this);
        }
        this._isUpdate = value;
    }

    get isUpdate() {
        return this._isUpdate;
    }

    get active() {
        return this._active;
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this.scale.y = value;
    }

    get pivotX() {
        return this._pivotX;
    }

    set pivotX(value) {
        this._pivotX = value;
        this.pivot.x = this._pivotX + this._positionDx;
    }

    get pivotY() {
        return this._pivotY;
    }

    set pivotY(value) {
        this._pivotY = value;
        this.pivot.y = this._pivotY + this._positionDy;
    }

    get anchorX() {
        return this.anchor.x;
    }

    set anchorX(value) {
        this.anchor.x = value;
    }

    get anchorY() {
        return this.anchor.y;
    }

    set anchorY(value) {
        this.anchor.y = value;
    }

    get localLeft() {
        return this._localBoundsRect.left;
    }

    get localRight() {
        return this._localBoundsRect.right;
    }

    get localTop() {
        return this._localBoundsRect.top;
    }

    get localBottom() {
        return this._localBoundsRect.bottom;
    }

    get localWidth() {
        return this._localBoundsRect.width;
    }

    get localHeight() {
        return this._localBoundsRect.height;
    }

    get globalLeft() {
        return this.getGlobalPosition().x + this.localLeft;
    }

    get globalTop() {
        return this.getGlobalPosition().y + this.localTop;
    }

    get worldX() {
        return this.getGlobalPosition().x;
    }

    get worldY() {
        return this.getGlobalPosition().y;
    }

    set text(value) {
        let text = this._textValue = "" + value;
        if (this._isLocText) {
            text = (this._toUpperCase) ? Omy.loc.getText(this._textValue).toUpperCase() : Omy.loc.getText(this._textValue);
        } else {
            text = (this._toUpperCase) ? this._textValue.toUpperCase() : this._textValue;
        }

        text = ((this._staticFirstText) ? this._staticFirstText : "") +
            text + ((this._staticLastText) ? this._staticLastText : "");
        if (this._textBreak) {
            if (Omy.isDesktop)
                text = StringUtils.findAndReplace(text, ["%d}", "%l}", "%p}"], "\n", "", "");
            else if (!Omy.isScreenPortrait)
                text = StringUtils.findAndReplace(text, ["%d}", "%l}", "%p}"], "", "\n", "");
            else
                text = StringUtils.findAndReplace(text, ["%d}", "%l}", "%p}"], "", "", "\n");
        }
        super.text = text;
        if (this._fontField) {
            this._fontField.text = super.text;
            super.text = " ";
            this.emit(this._onCountEvent);
            this.emit(this._onTextEvent);
            return;
        }

        this._checkScale();
        if (this._checkCustomW) {
            this.forceUpdateWidth();
        }
        if (this._charCount !== super.text.length) {
            this._charCount = super.text.length;
            this.emit(this._onCountEvent);
        }

        this.emit(this._onTextEvent);
        if (this._isLocalFont) {
            const percent = this.realSize / this._maxFontSize;
            this.pivot.x = this._pivotX + this._positionDx * percent;
            this.pivot.y = this._pivotY + this._positionDy * percent;
        }
    }

    set tint(value) {
        super.tint = Number(value);
    }

    get tint() {
        return super.tint;
    }

    set fillTint(value) {
        console.warn("OmyPixi.js v.2.0.0: fillTint not work. Pls use \"tint\"");
    }

    get fillTint() {
        console.warn("OmyPixi.js v.2.0.0: fillTint not work. Pls use \"tint\"");
        return null;
    }

    get text() {
        return super.text;
    }

    set splitText(value) {
        if (this._splitInsideText) return;
        if (!this._isSplitUpdate && value) {
            Omy.addUpdater(this._updateCheckSplit, this);
        } else if (this._isSplitUpdate && !value) {
            Omy.removeUpdater(this._updateCheckSplit, this);
        }
        this._isSplitUpdate = Boolean(value);
        this._splitText = value;
    }

    set splitInsideText(value) {
        if (!this._isSplitUpdate && value) {
            Omy.addUpdater(this._updateCheckSplit, this);
        } else if (this._isSplitUpdate && !value) {
            Omy.removeUpdater(this._updateCheckSplit, this);
        }
        this._isSplitUpdate = Boolean(value);
        this._splitInsideText = value;
    }

    get splitText() {
        return this._splitText;
    }

    get staticFirstText() {
        return this._staticFirstText;
    }

    set staticFirstText(value) {
        this._staticFirstText = value;
        this.text = this._textValue;
    }

    get staticLastText() {
        return this._staticLastText;
    }

    set staticLastText(value) {
        this._staticLastText = value;
        this.text = this._textValue;
    }

    get x() {
        this._oX = super.x;
        return this._oX;
    }

    set x(value) {
        super.x = this._oX = value;
        if (this._graphicOverlay)
            this._updateDebugPosition();
    }

    /**
     * @returns {boolean}
     */
    get checkFontSize() {
        return this._checkFontSize;
    }

    /**
     * @param {boolean}value
     */
    set checkFontSize(value) {
        this._checkFontSize = value;
    }

    /**
     * @returns {boolean}
     */
    get fullCheckFontSize() {
        return this._fullCheckFontSize;
    }

    /**
     * @param {boolean}value
     */
    set fullCheckFontSize(value) {
        this._fullCheckFontSize = value;
    }

    get y() {
        this._oY = super.y;
        return this._oY;
    }

    set y(value) {
        super.y = this._oY = value;
        if (this._graphicOverlay)
            this._updateDebugPosition();
    }

    get height() {
        if (this._graphicOverlay) {
            return this._graphicOverlay.height;
        }
        this._oHeight = super.height;
        return this._oHeight;
    }

    set height(value) {
        if (this._graphicOverlay) {
            return this._graphicOverlay.height = value;
        }
        return super.height = this._oHeight = value;
    }

    get width() {
        if (this._graphicOverlay) {
            return this._graphicOverlay.width;
        }
        this._oWidth = super.width;
        return this._oWidth;
    }

    set width(value) {
        if (this._graphicOverlay) {
            return this._graphicOverlay.width = value;
        }
        return super.width = this._oWidth = value;
    }

    get rotation() {
        return super.rotation;
    }

    set rotation(value) {
        super.rotation = value;
        if (this._graphicOverlay)
            this._graphicOverlay.rotation = value;
    }

    get fontStyle() {
        return this._fontStyle;
    }

    set fontSize(value) {
        this._fontDefSize = value;
        if (this._checkFontSize) {
            this._checkScale();
        } else {
            if (this._locTextConf && this._locTextConf[Omy.language] && !this._graphicOverlay) {
                const fontSize = (Omy.isScreenPortrait) ? this._locTextConf[Omy.language]["v_fontSize"] || this._locTextConf[Omy.language]["fontSize"] : this._locTextConf[Omy.language]["fontSize"];
                super.fontSize = fontSize || this._fontDefSize;
            } else {
                super.fontSize = this._fontDefSize;
            }
        }

        if (this._graphicOverlay) {
            this._graphicOverlay.width = Math.max(this._graphicOverlay.width, this._oWidth);
            this._graphicOverlay.height = Math.max(this._graphicOverlay.height, this._oHeight);
        }
    }

    get fontSize() {
        return this._fontDefSize;
    }

    get realSize() {
        return super.fontSize;
    }

    get oneLine() {
        return this._oneLine;
    }

    set oneLine(value) {
        this._oneLine = value;
        if (this._oneLine) {
            this.maxWidth = Number.MAX_VALUE;
        } else {
            this.maxWidth = this._maxWidthConst;
        }
    }

    get oType() {
        return this._oType;
    }

    get input() {
        return this._isCheckInput;
    }

    set input(value) {
        if (this.input) {
            this.interactive = value;
        } else if (value) {
            this._isCheckInput = true;
            this.interactive = true;
            this.on("pointerdown", this._down, this);
            this.on("pointerup", this._up, this);
            this.on("pointerupoutside", this._upOutSide, this);
            this.on("pointerover", this._over, this);
            this.on("pointerout", this._out, this);
        }
    }

    set drag(value) {
        if (!this.input)
            this.input = true;

        if (!this._isUpdate) this.isUpdate = true;

        this._isDrag = value;
        this._listenMouseUp = value;
        (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
        this._dragVertical = true;
        this._dragHorizontal = true;
    }

    set allowHorizontalDrag(value) {
        this._dragHorizontal = value;
    }

    set allowVerticalDrag(value) {
        this._dragVertical = value;
    }

    set interactChild(value) {
        this.interactiveChildren = value;
    }

    /**
     * Set text max width
     * @param {number} value
     */
    set textMaxWidth(value) {
        this._maxWidthConst = value;
        if (!this._oneLine) {
            this.maxWidth = this._maxWidthConst;
        }
        this.text = this._textValue;
    }

    /**
     * Set text max height
     * @param {number} value
     */
    set textMaxHeight(value) {
        this._maxHeight = value;
        this.text = this._textValue;
    }

    set soundUp(value) {
        this._soundUp = value;
    }

    set soundOver(value) {
        this._soundOver = value;
    }

    set joinUpdatePause(value) {
        if (this._joinUpdatePause !== value)
            if (value) Omy.removeUpdater(this._updateJoinPosition, this);
            else Omy.addUpdater(this._updateJoinPosition, this);
        this._joinUpdatePause = value;
    }

    get saveOnDestroy() {
        return this._saveOnDestroy;
    }

    set saveOnDestroy(value) {
        this._saveOnDestroy = value;
    }
}
